import React, { Component, useRef } from "react";
import PageHelmet from "../component/common/Helmet";
import ModalVideo from 'react-modal-video';
import { FiClock, FiUser, FiMessageCircle, FiHeart } from "react-icons/fi";
import { Link } from 'react-router-dom';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import emailjs from '@emailjs/browser';
const Result = () => {
    return (
        <p className="success-message">Your Message has been successfully sent. I will contact you soon.</p>
    )
}
class BlogDetails extends Component {
    constructor() {
        super()
        this.state = {
            isOpen: false,
            formData: {
                name: "",
                email: "",
                message: "",
                comment:"",
            },
            showSuccessMessage: false,
        }
        this.openModal = this.openModal.bind(this)
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    openModal() {
        this.setState({ isOpen: true })
    }
    handleInputChange(event) {
        const target = event.target;
        const name = target.name;
        const value = target.value;

        this.setState((prevState) => ({
            formData: {
                ...prevState.formData,
                [name]: value,
            },
        }));
    }

    handleSubmit(event) {
        event.preventDefault();

        // Do something with the form data, e.g., send it to a server
        const { name, email, message } = this.state.formData;
        // console.log("Form data:", { name, email, message });
        emailjs.send(
            'service_g1tscxv',
            'template_ovmcf48',
            this.state.formData,
            'user_6vxcnuagWVUfrPKzTihBU'
        )
            .then((result) => {
                console.log(result.text);

            },
                (error) => {
                    console.log(error.text);
                }
            );
        event.target.reset();
        // Close the modal or reset the form if needed
        this.setState({
            isOpen: false,
            formData: {
                name: "",
                email: "",
                message: "",
            },
            showSuccessMessage: true,
        });
        setTimeout(() => {
            this.setState({
                isOpen: false,
                formData: {
                    name: "",
                    email: "",
                    message: "",
                },
                showSuccessMessage: false,
            });
        }, 5000);
    }
    render() {
        return (
            <React.Fragment>
                <PageHelmet pageTitle='MassCloud' />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190 bg_image bg_image--7" data-black-overlay="7">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="blog-single-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">mass.Dev <br /> The Future Of Arabic Cloud Systems</h2>
                                    <ul className="blog-meta d-flex justify-content-center align-items-center">
                                        <li><FiClock />August 1, 2023</li>
                                        <li><FiUser />Massarwe</li>
                                        <li><FiMessageCircle />15 Comments</li>
                                        <li><FiHeart />Like</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Blog Details */}
                <div className="rn-blog-details pt--110 pb--70 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner-wrapper">
                                    <div className="inner">
                                        <p>MassDev is a pioneering technology company that is rapidly transforming industries in the Arab world through its innovative cloud-based Arabic ERP systems. With a steadfast commitment to providing cutting-edge solutions, MassDev is redefining the landscape of enterprise resource planning for businesses of all sizes and sectors. Our dedication to delivering excellence in the Arabic language and catering to the unique needs of Arab users sets us apart as leaders in the ERP domain.
                                        </p>
                                        {/* <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum. You need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend toitrrepeat predefined chunks. </p> */}
                                        <div className="thumbnail">
                                            <img src="/assets/images/blog/bl-big-01.jpg" alt="Blog Images" />
                                        </div>
                                        <p className="mt--40">
                                            One of MassDev's core strengths lies in its team of highly skilled and specialized UX designers who have deep expertise in Arabic language and culture. We understand the nuances and intricacies of the Arabic user, enabling us to craft seamless and intuitive interfaces that cater specifically to their preferences. By focusing on user experience, we ensure that our ERP systems provide a delightful and efficient experience, enhancing productivity and user satisfaction across the board.
                                        </p>
                                        <p>In the realm of frontend development, MassDev boasts an exceptional team of developers who are proficient in the latest frontend technologies. From utilizing cutting-edge JavaScript frameworks like React, Vue, and Next.js to leveraging the power of HTML and CSS, our frontend developers create visually stunning and responsive interfaces. By staying abreast of the latest industry trends, MassDev guarantees that its ERP systems deliver an unparalleled user experience.
                                        </p>
                                        <blockquote className="rn-blog-quote">Let’s get you one step closer to your goals
                                        </blockquote>
                                        <p>At the heart of MassDev's ERP systems lies a robust and reliable backend built on the strong foundation of Node.js. Our backend developers are experts in harnessing the full potential of Node.js to create scalable, secure, and high-performance systems. With meticulous attention to detail and a passion for perfection, our backend team ensures that the ERP systems are capable of handling complex business operations with utmost efficiency.</p>
                                        {/* <div className="blog-single-list-wrapper d-flex flex-wrap">
                                            <div className="thumbnail">
                                                <img className="w-100" src="/assets/images/blog/blog-single-01.png" alt="BLog Images" />
                                                <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do</span>
                                            </div>
                                            <div className="content">
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo .</p>
                                                <h4 className="title">Ordered & Unordered Lists.</h4>
                                                <ul className="list-style">
                                                    <li>Yet this above sewed flirted opened ouch</li>
                                                    <li>Goldfinch realistic sporadic ingenuous</li>
                                                    <li>Abominable this abidin far successfully then like piquan</li>
                                                    <li>Risus commodo viverra</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing</li>
                                                </ul>
                                                <h4 className="title">Ordered & Unordered Lists.</h4>
                                                <ul className="list-style">
                                                    <li>Yet this above sewed flirted opened ouch</li>
                                                    <li>Goldfinch realistic sporadic ingenuous</li>
                                                    <li>Abominable this abidin far successfully then like piquan</li>
                                                    <li>Risus commodo viverra</li>
                                                </ul>
                                            </div>
                                        </div> */}

                                        <p className="mt--25 mt_sm--5">MassDev takes pride in its commitment to continuously evolving and improving its offerings. We understand that the business landscape is dynamic, and so, we strive to remain at the forefront of technological advancements. Through regular updates and enhancements, we ensure that our ERP systems are equipped with the latest features and functionalities, providing our clients with a competitive edge in their respective industries.</p>
                                        <div className="video-wrapper position-relative mb--40">
                                            <div className="thumbnail">
                                                <img src="/assets/images/blog/vid-thump.jpg" alt="Blog Images" />
                                            </div>
                                            <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='EsTGYaRucTg' onClose={() => this.setState({ isOpen: false })} />
                                            <button className="video-popup position-top-center" onClick={this.openModal}><span className="play-icon"></span></button>
                                        </div>
                                        <p className="mb--0">In conclusion, MassDev is a trailblazing company revolutionizing the Arab world's industries with its cloud-based Arabic ERP systems. With an unrivaled focus on user experience and a team of top-tier developers proficient in frontend and backend technologies, MassDev delivers state-of-the-art solutions to businesses across diverse sectors. As we continue to evolve and expand our offerings, MassDev remains committed to empowering businesses with the tools they need to thrive in the ever-changing digital landscape of the Arab world.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Blog Details */}

                {/* Start BLog Comment Form  */}
                <div className="blog-comment-form pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner">
                                    <h3 className="title mb--40 fontWeight500">Leave a Meassage</h3>
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-12 col-12">
                                                <div className="rnform-group">
                                                    <input type="text" placeholder="Name"
                                                        name="name"
                                                        onChange={this.handleInputChange}
                                                        required
                                                    />
                                                </div>
                                                <div className="rnform-group">
                                                    <input type="email" placeholder="Email" name="email"
                                                        value={this.state.formData.email}
                                                        onChange={this.handleInputChange}
                                                        required
                                                    />
                                                </div>
                                                <div className="rnform-group">
                                                    <input type="text" placeholder="Message"
                                                        name="message"
                                                        value={this.state.formData.message}
                                                        onChange={this.handleInputChange}
                                                        required />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-12">
                                                {/* <div className="rnform-group">
                                                    <textarea type="text" placeholder="Comment" name="comment"
                                                        value={this.state.formData.comment}
                                                        onChange={this.handleInputChange}></textarea>
                                                </div> */}

                                            </div>
                                            <div className="col-lg-6 col-md-12 col-12">
                                                <button class="rn-button-style--2 btn-solid" type="submit" value="submit" name="submit" id="mc-embedded-subscribe">SEND MESSAGE</button>

                                            </div>
                                            {/* <div className="col-lg-12">
                                                <div className="blog-btn">
                                                    <Link className="rn-button-style--2 btn-solid" to="/blog-details"><span>SEND MESSAGE</span></Link>
                                                </div>
                                            </div> */}
                                        </div>
                                        <div className="rn-form-group">
                                            {this.state.showSuccessMessage && <Result />}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End BLog Comment Form  */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

                <Footer />

            </React.Fragment>
        )
    }
}
export default BlogDetails;